function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36",
  height: "36",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F1F3F4",
  width: "36",
  height: "36",
  rx: "5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.71 15.569l.078.04a.465.465 0 00.523-.106l4.743-4.982 4.937 4.99.072.058a.47.47 0 00.601-.065.49.49 0 00-.006-.68L18.38 9.49l-.072-.059a.47.47 0 00-.6.066l-5.077 5.333-.067.088a.491.491 0 00.073.592l.072.059zM12.71 20.581l.078-.04a.465.465 0 01.523.106l4.743 4.982 4.937-4.99.072-.058a.47.47 0 01.601.065.49.49 0 01-.006.68L18.38 26.66l-.072.059a.47.47 0 01-.6-.066l-5.077-5.333-.067-.088a.491.491 0 01.073-.592l.072-.059z",
  fill: "#54585D"
}))));